module.exports = __webpack_public_path__ + "img/close-red-icon.ed368739.svg";